var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsTradeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 9.20825V13.1666M16.4997 13.1666H12.5413M16.4997 13.1666L12.5413 9.20825C11.8423 8.50921 11.4932 8.16009 11.0649 8.12129C10.9938 8.11487 10.9222 8.11487 10.8511 8.12129C10.4228 8.16088 10.0737 8.50921 9.37467 9.20825C8.67563 9.90729 8.32651 10.2564 7.89822 10.2952C7.82697 10.3015 7.75572 10.3015 7.68447 10.2952C7.25617 10.2556 6.90705 9.90729 6.20801 9.20825L3.83301 6.83325",
    stroke: "#EF4444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsTradeDown);
export default __webpack_public_path__ + "static/media/hugeicons_trade-down.ac2607606734c07460a32be8c5853dc5.svg";
export { ForwardRef as ReactComponent };